module.exports = __webpack_public_path__ + "img/icon_zurueck.e6aca39b.svg";